import React from "react";
import { useT } from "@/i18n/I18nContext";
import MilestoneOverlay from "./MilestoneOverlay";

// Localised headline — inline copy, same pattern as the other mascot overlays.
const COPY = {
  it: "Che bella dormita! 😴",
  en: "What a great night's sleep! 😴",
  de: "Erholsame Nacht geschafft! 😴",
  fr: "Quelle bonne nuit de sommeil ! 😴",
};

/**
 * Sleep-goal celebration overlay — fires once per day (morning) from the
 * Dashboard when TODAY's synced sleep reaches the sleep target.
 */
export default function SleepGoalOverlay({ show, onClose, sleepMinutes = null }) {
  const { lang } = useT();
  let sub = null;
  if (sleepMinutes) {
    const hh = Math.floor(sleepMinutes / 60);
    const mm = Math.round(sleepMinutes % 60);
    sub = `${hh}h${mm ? ` ${mm}m` : ""} 🌙`;
  }
  return (
    <MilestoneOverlay
      show={show}
      onClose={onClose}
      mascotSrc="/mascot/sleep-goal-512.png"
      mascotAlt="Solano"
      title={COPY[lang] || COPY.it}
      subtitle={sub}
      confettiColors={["#3B4FD8", "#7ECEE5"]}
      size="lg"
      testId="sleep-goal-overlay"
    />
  );
}
